import React from "react";
import {
  Container,
  Typography,
  Divider,
  Box,
  Stack,
} from "@mui/material";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import { useParams } from "react-router-dom";

const PrivacyPolicy = () => {
  const { id } = useParams();
  const showLayout = id === "1";

  const sections = [
    {
      number: "01",
      title: "Introduction",
      content:
        "This Privacy Policy describes Our policies and procedures on the collection, use, and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You. We use Your Personal Data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.",
    },
    {
      number: "02",
      title: "Interpretation and Definitions",
      content:
        "The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or plural.",
    },
    {
      number: "03",
      title: "Definitions",
      content:
        'For the purposes of this Privacy Policy, "Account" means a unique account created for You to access our Service or parts of our Service. "Company" refers to Hindustan Wardrobe Private Limited, Bharwani, Madhya Pradesh.',
    },
    {
      number: "04",
      title: "Collecting and Using Your Personal Data",
      content:
        "We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:",
      list: [
        "Email address",
        "First name and last name",
        "Phone number",
        "Address",
        "State",
        "Province",
        "ZIP / Postal code",
        "City",
      ],
    },
    {
      number: "05",
      title: "Usage Data",
      content:
        "Usage Data is collected automatically when using the Service. This includes details like Your device's Internet Protocol address (IP address), browser type, the pages of our Service that You visit, and other diagnostic data.",
    },
    {
      number: "06",
      title: "Use of Your Personal Data",
      content:
        "The Company may use Personal Data for the following purposes:",
      list: [
        "To provide and maintain our Service.",
        "To manage Your Account.",
        "For the performance of a contract.",
        "To contact You via email, phone, or SMS.",
        "For business transfers.",
      ],
    },
    {
      number: "07",
      title: "Disclosure of Your Personal Data",
      content:
        "In the case of business transactions, mergers, or acquisitions, Your personal information may be transferred. We will provide notice before Your Personal Data is transferred to another party.",
    },
    {
      number: "08",
      title: "Security of Your Personal Data",
      content:
        "The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.",
    },
    {
      number: "09",
      title: "Changes to this Privacy Policy",
      content:
        "We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.",
    },
  ];

  return (
    <>
      {showLayout && <Navbar />}

      <Box
        sx={{
          background: "#F7F4EF",
          minHeight: "100vh",
          color: "#171717",
        }}
      >
        <Box
          sx={{
            borderBottom: "1px solid #DDD7CE",
            py: { xs: 7, md: 10 },
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              width: 340,
              height: 340,
              border: "1px solid rgba(151,119,67,0.12)",
              borderRadius: "50%",
              right: { xs: -180, md: -100 },
              top: -170,
            }}
          />

          <Box
            sx={{
              position: "absolute",
              width: 190,
              height: 190,
              border: "1px solid rgba(151,119,67,0.1)",
              borderRadius: "50%",
              left: { xs: -110, md: -60 },
              bottom: -110,
            }}
          />

          <Container
            maxWidth="lg"
            sx={{
              position: "relative",
              zIndex: 1,
            }}
          >
            <Typography
              sx={{
                fontSize: 11,
                letterSpacing: "0.3em",
                textTransform: "uppercase",
                color: "#977743",
                fontWeight: 600,
                mb: 2.5,
              }}
            >
              Hindustan Wardrobe · Your Privacy
            </Typography>

            <Typography
              component="h1"
              sx={{
                fontFamily: "Georgia, serif",
                fontWeight: 400,
                fontSize: {
                  xs: 48,
                  sm: 62,
                  md: 78,
                },
                lineHeight: 0.98,
                letterSpacing: "-0.03em",
                maxWidth: 800,
                mb: 3,
              }}
            >
              Privacy
              <br />
              <Box component="span" sx={{ fontStyle: "italic" }}>
                Policy
              </Box>
            </Typography>

            <Typography
              sx={{
                color: "#68635C",
                fontSize: { xs: 14, md: 16 },
                lineHeight: 1.8,
                maxWidth: 620,
              }}
            >
              Your privacy matters to us. Learn how Hindustan Wardrobe
              collects, uses, protects and manages your personal information.
            </Typography>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                mt: 3,
              }}
            >
              <Box
                sx={{
                  width: 42,
                  height: 1,
                  background: "#977743",
                }}
              />

              <Typography
                sx={{
                  fontSize: 11,
                  letterSpacing: "0.12em",
                  textTransform: "uppercase",
                  color: "#77716A",
                }}
              >
                Last updated · April 01, 2025
              </Typography>
            </Box>
          </Container>
        </Box>

        <Container
          maxWidth="md"
          sx={{
            py: { xs: 6, md: 9 },
          }}
        >
          <Box
            sx={{
              background: "#171717",
              color: "#fff",
              p: { xs: 3.5, md: 5 },
              mb: { xs: 6, md: 8 },
            }}
          >
            <Typography
              sx={{
                fontSize: 10,
                letterSpacing: "0.25em",
                textTransform: "uppercase",
                color: "#C4A36A",
                mb: 2,
              }}
            >
              Your Information
            </Typography>

            <Typography
              sx={{
                fontFamily: "Georgia, serif",
                fontSize: { xs: 24, md: 30 },
                lineHeight: 1.4,
              }}
            >
              We believe privacy should be clear, transparent and easy to
              understand.
            </Typography>
          </Box>

          <Stack spacing={0}>
            {sections.map((section, index) => (
              <Box
                key={section.number}
                sx={{
                  pb: 5,
                  mb: 5,
                  borderBottom:
                    index === sections.length - 1
                      ? "none"
                      : "1px solid #DDD7CE",
                }}
              >
                <Stack
                  direction="row"
                  spacing={{ xs: 2, md: 3 }}
                  alignItems="flex-start"
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      letterSpacing: "0.15em",
                      color: "#977743",
                      fontWeight: 600,
                      minWidth: 30,
                      pt: 0.5,
                    }}
                  >
                    {section.number}
                  </Typography>

                  <Box sx={{ flex: 1 }}>
                    <Typography
                      component="h2"
                      sx={{
                        fontFamily: "Georgia, serif",
                        fontSize: { xs: 27, md: 32 },
                        fontWeight: 400,
                        lineHeight: 1.2,
                        mb: 2.5,
                      }}
                    >
                      {section.title}
                    </Typography>

                    <Typography
                      sx={{
                        color: "#625E58",
                        fontSize: 15,
                        lineHeight: 1.9,
                      }}
                    >
                      {section.content}
                    </Typography>

                    {section.list && (
                      <Stack spacing={1.2} sx={{ mt: 2.5 }}>
                        {section.list.map((item) => (
                          <Box
                            key={item}
                            sx={{
                              display: "flex",
                              alignItems: "flex-start",
                              gap: 1.5,
                            }}
                          >
                            <Box
                              sx={{
                                width: 5,
                                height: 5,
                                minWidth: 5,
                                borderRadius: "50%",
                                background: "#977743",
                                mt: "9px",
                              }}
                            />

                            <Typography
                              sx={{
                                color: "#625E58",
                                fontSize: 15,
                                lineHeight: 1.7,
                              }}
                            >
                              {item}
                            </Typography>
                          </Box>
                        ))}
                      </Stack>
                    )}
                  </Box>
                </Stack>
              </Box>
            ))}

            <Box
              sx={{
                background: "#EEE9E1",
                p: { xs: 3.5, md: 5 },
                mt: 1,
              }}
            >
              <Typography
                sx={{
                  fontSize: 11,
                  letterSpacing: "0.2em",
                  textTransform: "uppercase",
                  color: "#977743",
                  fontWeight: 600,
                  mb: 2,
                }}
              >
                10 · Contact Us
              </Typography>

              <Typography
                component="h2"
                sx={{
                  fontFamily: "Georgia, serif",
                  fontSize: { xs: 28, md: 34 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                Have questions about your privacy?
              </Typography>

              <Typography
                sx={{
                  color: "#625E58",
                  fontSize: 15,
                  lineHeight: 1.8,
                  mb: 3,
                }}
              >
                If you have any questions about this Privacy Policy, you can
                contact our support team.
              </Typography>

              <Divider sx={{ borderColor: "#D5CEC3", mb: 3 }} />

              <Typography
                sx={{
                  fontSize: 14,
                  color: "#292929",
                }}
              >
                <Box component="span" sx={{ fontWeight: 700 }}>
                  Email:
                </Box>{" "}
                <Box
                  component="a"
                  href="mailto:info@hindustanwardrobe.in"
                  sx={{
                    color: "#977743",
                    textDecoration: "none",
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  info@hindustanwardrobe.in
                </Box>
              </Typography>
            </Box>
          </Stack>
        </Container>
      </Box>

      {showLayout && <Footer />}
    </>
  );
};

export default PrivacyPolicy;